// extracted by mini-css-extract-plugin
export default {"root":"T3BUDABIhWiv2BsedDpo","vertical":"Qe5Rs9n1oDPHf5BH_Kew","image":"PHG9J8ua_EZ6BH5couJS","thumbs":"xfRKs5ckcYkHvnasOmmO","placeHolderShimmer":"rEKuK3y8C5cdaRuHkZ4P"};